export default {
  title: 'Deine Rezension hilft uns sehr ❤️',
  description: 'Bewerte {{name}} im {{store}} – einfach einen Stern tippen.',
  buttons: {
    not_now: 'Nicht jetzt',
    continue: 'Weiter',
  },
};
